module.exports = __webpack_public_path__ + "static/media/event-services-img24.baade71c.jpg";